import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'bull' | 'bear' | 'accent' | 'warn' | 'subtle' | 'gold';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  size?: 'sm' | 'md';
}

const toneClasses: Record<Tone, string> = {
  neutral: 'bg-bg-elevated text-fg-muted border border-border',
  bull:    'bg-bull/12 text-bull border border-bull/30',
  bear:    'bg-bear/12 text-bear border border-bear/30',
  accent:  'bg-accent/12 text-accent border border-accent/30',
  warn:    'bg-warn/12 text-warn border border-warn/30',
  subtle:  'bg-bg-subtle text-fg-subtle',
  gold:    'bg-amber-400/12 text-amber-400 border border-amber-400/30',
};

export function Badge({ tone = 'neutral', size = 'sm', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-semibold tabular',
        size === 'sm' ? 'text-2xs px-2 py-0.5 h-5' : 'text-xs px-2.5 py-0.5 h-6',
        toneClasses[tone],
        className,
      )}
      {...rest}
    />
  );
}
